/**
 * Envia um evento para o dataLayer do Google Tag Manager.
 *
 * Usa `window.dataLayer` de forma defensiva: se o GTM ainda não carregou
 * (ou foi bloqueado por um ad blocker) o clique do usuário continua
 * funcionando em vez de estourar um ReferenceError.
 */
const trackEvent = (event, payload = {}) => {
  if (typeof window === "undefined") return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...payload })
}

export default trackEvent
